var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-sort-down';
                    var viewUrl = 'gfx/sprite.svg#view-icon-sort-down';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 6',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };